import { render, staticRenderFns } from "./app-root.vue?vue&type=template&id=85511546"
import script from "./app-root.vue?vue&type=script&lang=js"
export * from "./app-root.vue?vue&type=script&lang=js"
import style0 from "./app-root.vue?vue&type=style&index=0&id=85511546&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports